import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import {V2CardAgentToolName} from '../../promptToCardAgentV2.enums';
import {z} from 'zod';
import {ToolExecuteParams, ToolResult} from 'common/src/modules/shared/copilot/copilot.types';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import toolError from 'common/src/modules/shared/copilot/utils/toolError';
import {ContentCardScratchpadState} from '../../scratchpad/contentCardScratchpad.types';
import validateAgentScratchpad from '../../utils/general/validateAgentScratchpad';
import {NodeType} from 'common/src/modules/nodes/nodes.types';
import {ContentSelectionStrategyValue} from 'common/src/modules/contentFeeds/contentFeeds.enums';
import {contentFeedItemsApi} from 'common/src/modules/contentFeedItems/contentFeedItems.api';

const inputSchema = z.object({
  contentId: z.string().describe('The specific content ID to use'),
});

async function execute(
  params: ToolExecuteParams<typeof inputSchema, ContentCardScratchpadState>,
): Promise<ToolResult> {
  const {
    input: {contentId},
    toolUtils: {agentScratchpad},
  } = params;
  const validatedScratchpad = validateAgentScratchpad<ContentCardScratchpadState>(
    agentScratchpad,
    NodeType.CONTENT_FEED,
  );

  if (validatedScratchpad.card.strategy !== ContentSelectionStrategyValue.Specific) {
    return toolError(
      `You can only set specific content for specific content selection strategy, selected strategy is: ${validatedScratchpad.card.strategy}`,
    );
  }

  const contentItems = await contentFeedItemsApi.getFeedItemsByIds(
    validatedScratchpad.card.contentFeedId,
    [contentId],
  );

  if (!contentItems.items.length || !contentItems.items[0]) {
    return toolError(`Content item with ID ${contentId} not found in the feed`);
  }

  validatedScratchpad.card.contentId = contentId;

  return toolResult(`Specific content set: ${contentId}`);
}

export default function setSpecificContentTool() {
  return tool({
    name: V2CardAgentToolName.SetSpecificContent,
    displayName: 'Setting specific content',
    description: 'Set a specific content ID when using the Specific strategy',
    inputSchema,
    execute,
  });
}
